import { getAffiliateCardOffer, getToken } from '../services/digitalPrescreen'

export async function getLendingTreeCardOffer() {
  const searchParams = new URLSearchParams(window.location.search)
  const strategyId = searchParams.get('strategy')
  const encodedLineAmount = searchParams.get('la')

  const token = await getToken()
  const data = await getAffiliateCardOffer(token, strategyId, encodedLineAmount)

  const transformedData = {
    data: {
      cardOffer: { ...data.cardOffer, prefillLink: data.prefillLink }
    }
  }
  return transformedData
}
